
import React from 'react';
import { Route } from 'react-router-dom';
import AuthGuard from '@/components/auth/AuthGuard';

// Author Pages
import AuthorDashboard from '@/pages/author/AuthorDashboard';
import AuthorGuide from '@/pages/author/AuthorGuide';
import HelpCenter from '@/pages/author/HelpCenter';
import TicketSuccess from '@/pages/author/TicketSuccess';
import PaymentRequest from '@/pages/author/PaymentRequest';
import PaymentSuccess from '@/pages/author/PaymentSuccess';
import RoyaltyReports from '@/pages/author/RoyaltyReports';
import RoyaltyDetail from '@/pages/author/RoyaltyDetail';
import AuthorPayments from '@/pages/author/AuthorPayments';
import PaymentPreferences from '@/pages/author/PaymentPreferences';
import AuthorAccountSettings from '@/pages/author/AuthorAccountSettings';
import AuthorTickets from '@/pages/author/AuthorTickets';
import AuthorTicketDetail from '@/pages/author/AuthorTicketDetail';
import AuthorBooks from '@/pages/author/AuthorBooks';

const AuthorRoutes = () => {
  return [
    <Route key="author-dashboard" path="/author/dashboard" element={
      <AuthGuard allowedRoles={['author']}>
        <AuthorDashboard />
      </AuthGuard>
    } />,
    <Route key="author-guide" path="/author/guide" element={
      <AuthGuard allowedRoles={['author']}>
        <AuthorGuide />
      </AuthGuard>
    } />,
    <Route key="author-royalties" path="/author/royalties" element={
      <AuthGuard allowedRoles={['author']}>
        <RoyaltyReports />
      </AuthGuard>
    } />,
    <Route key="author-royalty-detail" path="/author/royalties/:id" element={
      <AuthGuard allowedRoles={['author']}>
        <RoyaltyDetail />
      </AuthGuard>
    } />,
    <Route key="author-help" path="/author/help" element={
      <AuthGuard allowedRoles={['author']}>
        <HelpCenter />
      </AuthGuard>
    } />,
    <Route key="author-help-ticket" path="/author/help/ticket" element={
      <AuthGuard allowedRoles={['author']}>
        <HelpCenter />
      </AuthGuard>
    } />,
    <Route key="author-help-success" path="/author/help/success" element={
      <AuthGuard allowedRoles={['author']}>
        <TicketSuccess />
      </AuthGuard>
    } />,
    <Route key="author-tickets" path="/author/tickets" element={
      <AuthGuard allowedRoles={['author']}>
        <AuthorTickets />
      </AuthGuard>
    } />,
    <Route key="author-ticket-detail" path="/author/tickets/:id" element={
      <AuthGuard allowedRoles={['author']}>
        <AuthorTicketDetail />
      </AuthGuard>
    } />,
    <Route key="author-payments" path="/author/payments" element={
      <AuthGuard allowedRoles={['author']}>
        <AuthorPayments />
      </AuthGuard>
    } />,
    <Route key="author-payment-request" path="/author/payments/request" element={
      <AuthGuard allowedRoles={['author']}>
        <PaymentRequest />
      </AuthGuard>
    } />,
    <Route key="author-payment-success" path="/author/payments/success" element={
      <AuthGuard allowedRoles={['author']}>
        <PaymentSuccess />
      </AuthGuard>
    } />,
    <Route key="author-payment-preferences" path="/author/payment-preferences" element={
      <AuthGuard allowedRoles={['author']}>
        <PaymentPreferences />
      </AuthGuard>
    } />,
    <Route key="author-account" path="/author/account" element={
      <AuthGuard allowedRoles={['author']}>
        <AuthorAccountSettings />
      </AuthGuard>
    } />,
    <Route key="author-books" path="/author/books" element={
      <AuthGuard allowedRoles={['author']}>
        <AuthorBooks />
      </AuthGuard>
    } />
  ];
};

export default AuthorRoutes;
